module.exports = __webpack_public_path__ + "assets/img/btn-view-info-cbedab9f.png";